export const statusEnum = {
    CREATED: 'criado',
    INVITED: 'convidado',
    REJECTED: 'rejeitado',
    ACCEPTED: 'aceito',
    SHOWED_UP: 'compareceu',
    MISSED: 'não compareceu',
};
